export const padLeft = (value : number) : string => {
  if (value < 10) {
    return `0${value.toString()}`;
  }

  return value.toString();
};
